// Backend address comes from the environment: REACT_APP_API_BASE_URL (see .env.example)
export const baseUrl = (process.env.REACT_APP_API_BASE_URL || "").replace(/\/+$/, "");
if (!baseUrl) {
  console.error("REACT_APP_API_BASE_URL is not set. Add it to your .env file (see .env.example) and restart.");
}
const URL = `${baseUrl}/api`;
export default  URL;
